import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./navbar";
import Footer from "./footer";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = window.sessionStorage.getItem("jwtToken");

const Stocks = () => {
  const [allStrategies, setAllStrategies] = useState([]);
  const [editId, setEditId] = useState(null);
  const [showRebalanceModal, setShowRebalanceModal] = useState(false);
  const [selectedStrategy, setSelectedStrategy] = useState(null);
  const [businessDate, setBusinessDate] = useState("");
  const [formData, setFormData] = useState({
    strategyCode: "",
    title: "",
    description: "",
    features: "",
    tag: "",
    iconURL: "",
    subscriptionStatus: 0,
    yearlyprice: "",
    monthlyprice: "",
    quarterlyprice: "",
    subscribed: false,
  });
  const [showForm, setShowForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BASE_URL}/home/stocks/with-subscriptions/1`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((response) => {
        const strategies = response.data?.strategies || [];
        setAllStrategies(strategies);
      })
      .catch((err) => console.error("Error fetching:", err));
  }, []);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = allStrategies.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(allStrategies.length / itemsPerPage);

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid">
          <div
            className="d-flex justify-content-between mb-3"
            style={{ marginTop: "10px" }}
          >
            <button
              className="btn btn-primary mb-3"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
            <h2 className="fw-bold">Stocks</h2>
            <h2></h2>
          </div>

          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Strategy Code</th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Features</th>
                  <th>Tag</th>
                  <th>Icon URL</th>
                  <th>Subscription Status</th>
                  <th>Yearly Price</th>
                  <th>Monthly Price</th>
                  <th>Quarterly Price</th>
                  {/* <th>Subscribed</th> */}
                  {/* <th>Action</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item, idx) => (
                  <tr key={idx}>
                    <td>{indexOfFirstItem + idx + 1}</td>
                    <td>{item.strategyCode}</td>
                    <td>{item.title}</td>
                    <td>{item.description}</td>
                    <td>
                      {Array.isArray(item.features)
                        ? item.features.join(", ")
                        : item.features}
                    </td>
                    <td>{item.tag}</td>
                    <td>{item.iconURL}</td>
                    <td>{item.subscriptionStatus}</td>
                    <td>{item.yearlyPrice}</td>
                    <td>{item.monthlyPrice}</td>
                    <td>{item.quarterlyPrice}</td>
                    <td>
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => {
                          navigate("/liveFilteredStocks", {
                            replace: true,
                            state: {
                              strategyCode: item.strategyCode,
                            },
                          });
                        }}
                      >
                        Rebalance
                      </button>
                    </td>
                    {/* <td  
                      style={{ cursor: 'pointer', color: 'blue' }}
                      onClick={() => navigate(`/strategy-user-details/${item.strategyCode}`)} >{item.isSubscribed}
                    </td> */}
                    {/* <td>
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => {
                          setFormData({
                            strategyCode: item.strategyCode,
                            title: item.title,
                            description: item.description,
                            features: Array.isArray(item.features) ? item.features.join(', ') : item.features,
                            tag: item.tag,
                            iconURL: item.iconURL,
                            subscriptionStatus: item.subscriptionStatus,
                            yearlyprice: item.yearlyprice,
                            monthlyprice: item.monthlyprice,
                            quarterlyprice: item.quarterlyprice,
                            subscribed: item.subscribed
                          });
                          setEditId(item.id);
                          setShowForm(true);
                        }}
                      >
                        Edit
                      </button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>

            <nav className="d-flex justify-content-center mt-3">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                </li>
                {pageNumbers.map((number) => (
                  <li key={number} className="page-item">
                    <button
                      className={`page-link ${number === currentPage ? "active" : ""}`}
                      onClick={() => paginate(number)}
                    >
                      {number}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === pageNumbers.length}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Stocks;
